import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputMask } from "primereact/inputmask";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Row } from "primereact/row";
import { SelectButton } from "primereact/selectbutton";
import { TabPanel, TabView } from "primereact/tabview";
import CardSeplag from "../../../components/CardSeplag";
import ModalSeplag from "../../../components/ModalSeplag";
import Rotulo from "../../../components/RotuloSeplag";
import Andamentos from "./andamentos";
import Restricoes from "./restricoes";
import TabAtributos from "./modal/tabAtributos";
import TabIndicadores from "./modal/tabIndicadores";
import TabExecucaoOrcamentaria from "./modal/tabExecucaoOrcamentaria";

import "./style.modules.scss";

import { useFormik } from "formik";

import {
  detailAlteracaoSucessoPadrao,
  detailCriacaoSucessoPadrao,
  optSimNao,
  printToast,
  summaryAlteracaoSucessoPadrao,
  summaryCriacaoSucessoPadrao,
} from "../../../config/global";

import { formataCasasDecimaisMostrar, formatarValor } from "../../../utils";

import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import {
  buscarPeloIdenPtaPaiFiplan,
  buscarSubUnidadesExecucaoSeap,
  buscarUnidadesExecucaoSeap,
  initForm,
  pesquisarPorId,
  salvar,
} from "../../../service/Monitora/Lancamentos";

const ModalLancamentosMonitora = ({
  visible,
  setVisible,
  ptaMonitora,
  isPodeEditar,
  isMONRL_ADMIN_CENTRAL,
}) => {
  const [form, setForm] = useState(initForm);
  const [headerModal, setHeaderModal] = useState("Lançamentos");
  const [visivelAcao, setVisivelAcao] = useState(false);
  const [visivelProduto, setVisivelProduto] = useState(false);
  const [visivelSubacao, setVisivelSubacao] = useState(false);
  const [visivelEtapa, setVisivelEtapa] = useState(false);
  const [percMedioExcProdAcao, setPercMedioExcProdAcao] = useState([]);
  const [percMedioTotal, setPercMedioTotal] = useState(null);
  const [showNovoAtributos, setShowNovoAtributos] = useState(null);
  const [showNewTabs, setShowNewTabs] = useState(null);
  const [etapa, setEtapa] = useState();
  const [unidadesSeap, setUnidadesSeap] = useState([]);
  const [subUnidadesSeap, setSubUnidadesSeap] = useState([]);

  const [visibilidade, setVisibilidade] = useState();

  function changeFlagPrioritario(value) {
    let tmpForm = { ...formik.values };
    if (value != null) {
      tmpForm.flagPrioritario = value;
    }
    setForm(tmpForm);
  }

  function setarUnidadesExecucaoSeap(codgUo, idenExercicio) {
    buscarUnidadesExecucaoSeap(codgUo, idenExercicio).then((res) => {
      let unidades = res.map((un) => {
        return { idenUnidade: un.idenUnidade, descUnidade: un.descUnidade };
      });
      setUnidadesSeap(unidades);
    });
  }

  function handleTabSubmit() {
    formik.handleSubmit();
  }

  function setarSubUnidadesExecucaoSeap(codgUo, idenExercicio, idenSetorPai) {
    buscarSubUnidadesExecucaoSeap(codgUo, idenExercicio, idenSetorPai).then((res) => {
      let subunidades = res.map((un) => {
        return { idenUnidade: un.idenUnidade, descUnidade: un.descUnidade };
      });
      setSubUnidadesSeap(subunidades);
    });
  }

  function calcularPercentualMedio(produtoAcao) {
    /* percentual médio de exceução dos produtos da ação */

    // calcular perc de execução por produto da ação
    let v_percMedioExecProdAcao = produtoAcao.map((prod) => {
      return {
        descElemento: prod.descElemento,
        descUnidadeMedida: prod.ptaFiplan.unidadeMedida.descUnidadeMedida,
        qtdeProdutoPrevisto: prod.qtdeProdutoPrevisto,
        qtdeRealizado: prod.qtdeRealizado,
        percMedio:
          +prod.qtdeProdutoPrevisto > 0
            ? parseFloat(((+prod.qtdeRealizado / +prod.qtdeProdutoPrevisto) * 100).toFixed(2))
            : 0,
      };
    });
    // calcular a média total dos produtos da ação
    var soma =
      v_percMedioExecProdAcao.reduce(function (soma, prod) {
        return soma + parseFloat(+prod.percMedio || 0);
      }, 0) / v_percMedioExecProdAcao.length;

    let v_percMedioTotal = soma || 0;
    setPercMedioTotal(v_percMedioTotal);

    setPercMedioExcProdAcao(v_percMedioExecProdAcao);
  }

  const tab1HeaderTemplate = (options) => {
    let classSelected = options.selected ? "p-button-raised p-button-info" : "p-button-raised p-button-secondary";
    return (
      <>
        <Button type="button" onClick={options.onClick} className={classSelected}>
          <i className="pi pi-tags" style={{ marginRight: ".3em" }} />
          {options.titleElement}
        </Button>
      </>
    );
  };
  const tab2HeaderTemplate = (options) => {
    let classSelected = options.selected ? "p-button-raised p-button-info" : "p-button-raised p-button-secondary";
    return (
      <>
        <Button type="button" onClick={options.onClick} className={classSelected} style={{ marginLeft: ".3em" }}>
          <i className="pi pi-info-circle" style={{ marginRight: ".3em" }} />
          {options.titleElement}
        </Button>
        <br />
      </>
    );
  };

  const tab3HeaderTemplate = (options) => {
    let classSelected = options.selected ? "p-button-raised p-button-info" : "p-button-raised p-button-secondary";
    return (
      <>
        <Button type="button" onClick={options.onClick} className={classSelected} style={{ marginLeft: ".6em" }}>
          <i className="pi pi-list" style={{ marginRight: ".3em" }} />
          {options.titleElement}
        </Button>
        <br />
      </>
    );
  };

  const tab4HeaderTemplate = (options) => {
    return (
      <>
        <div style={{ marginLeft: ".9em", marginTop: ".5em", color: form.status.tipoCor }}>
          <i className="pi pi-circle-on" style={{ marginRight: ".3em" }} />
          {options.titleElement}
        </div>
        <br />
      </>
    );
  };

  const tab5HeaderTemplate = (options) => {
    let classSelected = options.selected ? "p-button-raised p-button-info" : "p-button-raised p-button-secondary";
    return (
      <>
        <Button type="button" onClick={options.onClick} className={classSelected} style={{ marginLeft: ".9em" }}>
          <i className="pi pi-list" style={{ marginRight: ".3em" }} />
          {options.titleElement}
        </Button>
        <br />
      </>
    );
  };

  const tabCleanHeaderTemplate = (options) => {
    let classSelected = options.selected ? "p-button-raised p-button-info" : "p-button-raised p-button-secondary";
    return (
      <>
        <Button type="button" onClick={options.onClick} className={classSelected}>
          <i className="pi" style={{ marginRight: ".3em" }} />
          {options.titleElement}
        </Button>
      </>
    );
  };

  const colQtdProdPrevistoTemplate = (node, column) => {
    return (
      <span>
        <p style={{ textAlign: "center" }}>{formatarValor(formataCasasDecimaisMostrar(node.qtdeProdutoPrevisto), 0)}</p>
      </span>
    );
  };

  const colQtdRealizadoTemplate = (node, column) => {
    return (
      <span>
        <p style={{ textAlign: "center" }}>{formatarValor(formataCasasDecimaisMostrar(node.qtdeRealizado), 0)}</p>
      </span>
    );
  };

  const colPercMedioTemplate = (node, column) => {
    return (
      <span>
        <p style={{ textAlign: "center" }}>{formatarValor(formataCasasDecimaisMostrar(node.percMedio), 2)}%</p>
      </span>
    );
  };

  let footerGroupPercExecFisica = (
    <ColumnGroup>
      <Row>
        <Column footer="% Execução Total:" colSpan={4} footerStyle={{ textAlign: "right" }} />
        <Column footer={formatarValor(formataCasasDecimaisMostrar(percMedioTotal), 2) + "%"} />
      </Row>
    </ColumnGroup>
  );

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: form,
    validate: (data) => {

      const errors = {};

      const isValidDate = (dateStr) => {
        const dateRegex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
        const match = dateStr.match(dateRegex);

        if (!match) return false;

        const day = parseInt(match[1], 10);
        const month = parseInt(match[2], 10) - 1;
        const year = parseInt(match[3], 10);
        const date = new Date(year, month, day);

        return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
      };

      if (data.dataInicioRealizado && !isValidDate(data.dataInicioRealizado)) {
        printToast({ severity: "error", detail: "Data de início - Realizado é inválida" });
      }

      if (data.dataRevisaoPrevisto && !isValidDate(data.dataRevisaoPrevisto)) {
        printToast({ severity: "error", detail: "Data de revisão é inválida" });
      }

      if (data.dataFinalRealizado && !isValidDate(data.dataFinalRealizado)) {
        printToast({ severity: "error", detail: "Data de Término -  Realizado é inválida" });
      }

      return errors;
    },
    onSubmit: (values) => {
      let reg = /(\.)|(\/)|(\-)/g;
      let jsonPost = {
        ...values,
      };

      let summary = values.idenPtaMonitora > 0 ? summaryAlteracaoSucessoPadrao : summaryCriacaoSucessoPadrao;
      let detail = values.idenPtaMonitora > 0 ? detailAlteracaoSucessoPadrao : detailCriacaoSucessoPadrao;

      salvar(jsonPost).then((res) => {
        printToast({ summary, detail });
        //  setVisible(false);
        // setAtualizaList(true);
        //onSalvar && onSalvar();
      });
    },
  });

  const template = (options) => ({
    rightIconElement: "pi pi-user",
  });

  function isPodeEditarUnidadeExecucao({ isPodeEditar, visivelAcao, visibleSubAcao }) {
    let disabled = true;
    if (isPodeEditar) {
      if (visivelAcao === true || visibleSubAcao === true) {
        disabled = false;
      }
    }

    return disabled;
  }

  useEffect(() => {
    if (ptaMonitora) {
      pesquisarPorId(ptaMonitora.idenPtaMonitora).then((res) => {
        if (res.unidadeSeap != null) {
          let unidade = { idenUnidade: res.unidadeSeap.idenUnidade, descUnidade: res.unidadeSeap.descUnidade };
          res.unidadeSeap = unidade;
        }

        if (res.subUnidadeSeap != null) {
          let subUnidade = { idenUnidade: res.subUnidadeSeap.idenUnidade, descUnidade: res.subUnidadeSeap.descUnidade };
          res.subUnidadeSeap = subUnidade;
        }
        setForm({
          ...res,
        });

        if (res.unidadeSeap != null) {
          setarSubUnidadesExecucaoSeap(
            res.ptaFiplan.codgUo,
            res.ptaFiplan.exercicio.idenExercicio,
            res.unidadeSeap.idenUnidade
          );
        }

        setHeaderModal(
          res.ptaFiplan.tipoItemPta.descTipoItemPta +
            ": " +
            res.ptaFiplan.codgElemento +
            " - " +
            res.ptaFiplan.descElemento.toUpperCase()
        );
        if (res.ptaFiplan.tipoItemPta.siglTipoItemPta == "A") {
          setVisivelAcao(true);
        } else if (res.ptaFiplan.tipoItemPta.siglTipoItemPta == "P") {
          setVisivelProduto(true);
        } else if (res.ptaFiplan.tipoItemPta.siglTipoItemPta == "S") {
          setVisivelSubacao(true);
        } else if (res.ptaFiplan.tipoItemPta.siglTipoItemPta == "E") {
          setVisivelEtapa(true);
        }
        if (res.produtoAcao && res.produtoAcao != null) {
          calcularPercentualMedio(res.produtoAcao);
        }

        setarUnidadesExecucaoSeap(res.ptaFiplan.codgUo, res.ptaFiplan.exercicio.idenExercicio);
        //setarUnidadesExecucaoSeap(6101, 21);
      });
    }
  }, [ptaMonitora]);

  useEffect(() => {
    if (form.idenPtaMonitora !== 0) {
      if (form.ptaFiplan.exercicio.ano) {
        if (form.ptaFiplan.exercicio.ano >= 2024) {
          setShowNovoAtributos(true);
          setShowNewTabs(true);
        }
      }
    }
  }, [form]);

  useEffect(() => {
    setVisibilidade({
      visivelAcao: visivelAcao,
      visivelProduto: visivelProduto,
      visivelSubacao: visivelSubacao,
      visivelEtapa: visivelEtapa,
    });
  }, [visivelAcao, visivelProduto, visivelSubacao, visivelEtapa]);

  useEffect(() => {
    buscarPeloIdenPtaPaiFiplan(ptaMonitora.idenPtaMonitora).then((res) => {
      setEtapa(res);
    });
  }, []);


  return (
    <ModalSeplag tamanho="76vw" visible={visible} titulo={headerModal} fechar={() => setVisible(false)} type="NONE">
      <TabView>
        <TabPanel
          header="Atributos"
          headerTemplate={showNovoAtributos ? tabCleanHeaderTemplate : tab1HeaderTemplate}
          style={{ marginRight: "1em" }}
        >
          <form onSubmit={formik.handleSubmit} className="p-grid" style={showNovoAtributos ? { display: "none" } : {}}>
            <div className="p-fluid grid line-height-4">
              <div className="field col-6">
                <CardSeplag>
                  <div className="p-fluid grid line-height-4">
                    {(visivelAcao || visivelProduto || visivelSubacao) && (
                      <>
                        <Rotulo nome="Prioritário" cols="12 6">
                          <div className="field">
                            <SelectButton
                              optionLabel="name"
                              value={formik.values.flagPrioritario}
                              options={optSimNao}
                              onChange={(e) => changeFlagPrioritario(e.value)}
                              disabled={!isPodeEditar && !isMONRL_ADMIN_CENTRAL}
                            />
                          </div>
                        </Rotulo>

                        <hr className="hr-modal"></hr>
                      </>
                    )}

                    {(visivelAcao || visivelProduto || visivelSubacao || visivelEtapa) && (
                      <>
                        <Rotulo nome="Descrição:" cols="12">
                          <div className="field">
                            <p>{formik.values.ptaFiplan.descElemento}</p>
                          </div>
                        </Rotulo>
                        <hr className="hr-modal"></hr>
                      </>
                    )}

                    {visivelSubacao && (
                      <>
                        <Rotulo nome="Produto" cols="12">
                          <div className="field">
                            <p>
                              {formik.values.ptaFiplan.produto
                                ? formik.values.ptaFiplan.produto.descProduto
                                : "Não Possui"}
                            </p>
                          </div>
                        </Rotulo>
                        <hr className="hr-modal"></hr>
                      </>
                    )}
                    {(visivelProduto || visivelSubacao) && (
                      <>
                        <Rotulo nome="Unidade de Medida" cols="12">
                          <div className="field">
                            <p>
                              {formik.values.ptaFiplan.unidadeMedida
                                ? formik.values.ptaFiplan.unidadeMedida.descUnidadeMedida
                                : "Não Possui"}
                            </p>
                          </div>
                        </Rotulo>
                        <hr className="hr-modal"></hr>
                      </>
                    )}
                    {(visivelAcao || visivelProduto || visivelSubacao) && (
                      <div className="w-full">
                        <Rotulo nome="Unidade de execução" cols="12">
                          <div className="field">
                            <Dropdown
                              id="rowId"
                              emptyMessage="Dados não encontrados"
                              value={formik.values.unidadeSeap}
                              options={unidadesSeap}
                              optionLabel="descUnidade"
                              filter
                              showClear
                              filterBy="descUnidade"
                              placeholder="Selecione uma unidade de execução"
                              onChange={(e) => {
                                setForm({ ...formik.values, unidadeSeap: e.target.value });
                                setarSubUnidadesExecucaoSeap(
                                  formik.values.ptaFiplan.codgUo,
                                  formik.values.ptaFiplan.exercicio.idenExercicio,
                                  e.value.idenUnidade
                                );
                              }}
                              disabled={isPodeEditarUnidadeExecucao({
                                isPodeEditar: isPodeEditar,
                                visivelAcao: visivelAcao,
                                visibleSubAcao: visivelSubacao,
                              })}
                            />
                          </div>
                        </Rotulo>
                        <hr className="hr-modal"></hr>
                        <Rotulo nome="Sub-Unidade de execução" cols="12">
                          <div className="field">
                            <Dropdown
                              id="rowId"
                              emptyMessage="Dados não encontrados"
                              options={subUnidadesSeap}
                              value={formik.values.subUnidadeSeap}
                              onChange={(e) => {
                                setForm({ ...formik.values, subUnidadeSeap: e.target.value });
                              }}
                              optionLabel="descUnidade"
                              filter
                              showClear
                              filterBy="descUnidade"
                              placeholder="Selecione uma Sub-Unidade de execução"
                              disabled={isPodeEditarUnidadeExecucao({
                                isPodeEditar: isPodeEditar,
                                visivelAcao: visivelAcao,
                                visibleSubAcao: visivelSubacao,
                              })}
                            />
                          </div>
                        </Rotulo>
                        <hr className="hr-modal"></hr>
                      </div>
                    )}
                    {(visivelAcao || visivelProduto || visivelSubacao || visivelEtapa) && (
                      <div
                        className="col-12"
                        //Utilizavel
                      >
                        <Rotulo nome="Responsável" cols="12">
                          <div className="field">
                            <p>{form.pessoaResp ? form.pessoaResp.nomePessoa.toUpperCase() : "Não Informado"}</p>
                          </div>
                        </Rotulo>
                      </div>
                    )}
                  </div>
                </CardSeplag>
              </div>

              <div className="field col-6">
                <CardSeplag>
                  <Rotulo nome="Data de Início" cols="12" className="p-fluid grid">
                    <div className="p-fluid grid line-height-4">
                      <div className="field col-12 md:col-4 ">
                        <span>
                          <label htmlFor="inicioprevisto">Previsto</label>
                          <InputText
                            id="inicioprevisto"
                            value={formik.values.ptaFiplan.dataInicioPrevisto}
                            disabled={true}
                          />
                        </span>
                      </div>
                      <div className="field col-12 md:col-4 ">
                        <span>
                          <label htmlFor="iniciorealizado">Realizado</label>
                          <InputMask
                            mask="99/99/9999"
                            slotChar="__/__/____"
                            placeholder="__/__/____"
                            id="inicioprealizado"
                            value={formik.values.dataInicioRealizado}
                            onChange={(e) => setForm({ ...formik.values, dataInicioRealizado: e.target.value })}
                            disabled={!isPodeEditar || !visivelEtapa}
                            //disabled={visivelEtapa === true ? false : true}
                          />
                        </span>
                      </div>
                      <div className="field col-12 md:col-4 ">&nbsp;</div>
                    </div>
                  </Rotulo>
                  <hr className="hr-modal"></hr>
                  <Rotulo nome="Data de Término" cols="12" className="p-fluid grid">
                    <div className="p-fluid grid line-height-4">
                      <div className="field col-12 md:col-4 ">
                        <span>
                          <label htmlFor="terminoprevisto">Previsto</label>
                          <InputText
                            id="terminoprevisto"
                            value={formik.values.ptaFiplan.dataTerminoPrevisto}
                            disabled={true}
                          />
                        </span>
                      </div>
                      <div className="field col-12 md:col-4 ">
                        <span>
                          <label htmlFor="terminorealizado">Realizado</label>
                          <InputMask
                            mask="99/99/9999"
                            slotChar="__/__/____"
                            placeholder="__/__/____"
                            id="terminoprealizado"
                            value={formik.values.dataFinalRealizado}
                            onChange={(e) => setForm({ ...formik.values, dataFinalRealizado: e.target.value })}
                            disabled={!isPodeEditar || !visivelEtapa}
                            //disabled={visivelEtapa === true ? false : true}
                          />
                        </span>
                      </div>
                      <div className="field col-12 md:col-4 ">&nbsp;</div>
                    </div>
                  </Rotulo>
                  {(visivelProduto || visivelSubacao) && (
                    <>
                      <hr className="hr-modal"></hr>
                      <Rotulo nome="Meta Física do Produto" cols="12" className="p-fluid grid">
                        <div className="p-fluid grid line-height-4">
                          <div className="field col-12 md:col-4 ">
                            <span>
                              <label htmlFor="previstoatualizado">Previsto Atualizado</label>
                              <InputNumber
                                id="previstoatualizado"
                                value={formik.values.ptaFiplan.qtdeProdutoPrevisto}
                                mode="decimal"
                                minFractionDigits={3}
                                locale="pt-BR"
                                disabled={true}
                              />
                            </span>
                          </div>
                          <div className="field col-12 md:col-4 ">
                            <span>
                              <label htmlFor="previstorealizado">Realizado</label>
                              <InputNumber
                                id="previstorealizado"
                                value={formik.values.qtdeRealizado}
                                mode="decimal"
                                minFractionDigits={3}
                                locale="pt-BR"
                                onChange={(e) => setForm({ ...formik.values, qtdeRealizado: e.value })}
                                disabled={!isPodeEditar}
                              />
                            </span>
                          </div>
                          <div className="field col-12 md:col-4 ">
                            <span>
                              <label htmlFor="previstoinicial">Previsto Inicial</label>
                              <InputNumber
                                id="previstoinicial"
                                value={formik.values.qtdePrevistoOriginal}
                                mode="decimal"
                                minFractionDigits={3}
                                locale="pt-BR"
                                disabled={true}
                              />
                            </span>
                          </div>
                        </div>
                      </Rotulo>
                    </>
                  )}
                  {visivelAcao && (
                    <>
                      <hr className="hr-modal"></hr>
                      <div className="datatable-templating-center-header">
                        <DataTable
                          emptyMessage="Dados não encontrados"
                          header="Percentual médio de execução física:"
                          value={percMedioExcProdAcao}
                          footerColumnGroup={footerGroupPercExecFisica}
                          responsiveLayout="scroll"
                        >
                          <Column field="descElemento" header="Produto"></Column>
                          <Column field="descUnidadeMedida" header="Un. Medida"></Column>
                          <Column
                            field="qtdeProdutoPrevisto"
                            body={colQtdProdPrevistoTemplate}
                            header="Previsto atualizado"
                          ></Column>

                          <Column field="qtdeRealizado" body={colQtdRealizadoTemplate} header="Realizado"></Column>
                          <Column field="percMedio" body={colPercMedioTemplate} header="Execução"></Column>
                        </DataTable>
                      </div>
                    </>
                  )}
                </CardSeplag>

                <div className="p-fluid grid">
                  <div className="field col-12 md:col-9 ">&nbsp;</div>
                  <div className="field col-12 md:col-3 ">
                    <br></br>
                    {
                      //<Button label="Salvar" className="p-button-success" type="submit" />
                    }
                    <Button
                      label="Salvar"
                      icon={"pi pi-check"}
                      autoFocus
                      className="p-button-success"
                      disabled={!isPodeEditar}
                      type="submit"
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
          {showNovoAtributos && (
            <TabAtributos
              data={ptaMonitora}
              dataTable={percMedioExcProdAcao}
              dataFormik={form}
              percMedioTotal={percMedioTotal}
              unidadesExecucao={unidadesSeap}
              handleSubmit={() => handleTabSubmit()}
              setForm={setForm}
              changeFlagPrioritario={changeFlagPrioritario}
              isPodeEditar={isPodeEditar}
              visibilidade={visibilidade}
            />
          )}
        </TabPanel>
        {showNewTabs && visivelAcao && (
          <TabPanel header="Indicadores" headerTemplate={tabCleanHeaderTemplate} style={{ marginRight: "1em" }}>
            <TabIndicadores ptaMonitora={form} setFormPta={setForm} />
          </TabPanel>
        )}

        {showNewTabs && visivelAcao && (
          <TabPanel
            header="Execução Orçamentária"
            headerTemplate={tabCleanHeaderTemplate}
            style={{ marginRight: "1em" }}
          >
            <TabExecucaoOrcamentaria plan72RealizadoPrograma={formik.values.ptaFiplan.plan72RealizadoAcao} />
          </TabPanel>
        )}

        {visivelSubacao && (
          <TabPanel
            header="Restrições"
            className="p-button-raised p-button-secondary"
            headerTemplate={tab2HeaderTemplate}
            isPodeEditar={isPodeEditar}
          >
            <Restricoes
              ptaMonitora={form}
              setFormPta={setForm}
              setVisible={setVisible}
              isPodeEditar={isPodeEditar}
            ></Restricoes>
          </TabPanel>
        )}
        {(visivelProduto || visivelSubacao || visivelEtapa) && (
          <TabPanel header="Análise de Andamento" headerTemplate={tab3HeaderTemplate}>
            <Andamentos
              ptaMonitora={form}
              setFormPta={setForm}
              setVisible={setVisible}
              isPodeEditar={isPodeEditar}
            ></Andamentos>
          </TabPanel>
        )}
        {visivelSubacao && (
          <TabPanel header="Etapas" headerTemplate={tab5HeaderTemplate}>
            <DataTable
              sortField="ptaFiplan.codgElemento"
              sortOrder={1}
              header={"Etapas Subação"}
              value={etapa}
              responsiveLayout="scroll"
              className="p-datatable-striped"
            >
              <Column field="ptaFiplan.codgElemento" header="codigo" style={{ display: "none" }}></Column>
              <Column field="ptaFiplan.descricaoFiplan" header="ETAPA" style={{ width: "30%" }}></Column>
              <Column field="pessoaResp.nomePessoa" header="RESPONSÁVEL" style={{ width: "20%" }}></Column>
              <Column field="ptaFiplan.dataInicioPrevisto" header="INÍCIO PREVISTO" style={{ width: "10%" }}></Column>
              <Column field="ptaFiplan.dataTerminoPrevisto" header="TÉRMINO PREVISTO" style={{ width: "10%" }}></Column>
            </DataTable>
          </TabPanel>
        )}
        <TabPanel disabled header={form.status.descStatus} headerTemplate={tab4HeaderTemplate}></TabPanel>
      </TabView>
    </ModalSeplag>
  );
};

export default ModalLancamentosMonitora;
